import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SearchFilters, SearchContext } from '@/services/search';

interface SearchState {
  query: string;
  isOpen: boolean;
  recentSearches: string[];
  filters: SearchFilters;
  context: SearchContext;
  setQuery: (query: string) => void;
  open: () => void;
  close: () => void;
  clear: () => void;
  addRecentSearch: (query: string) => void;
  clearRecentSearches: () => void;
  setFilters: (filters: Partial<SearchFilters>) => void;
  clearFilters: () => void;
  setContext: (ctx: SearchContext) => void;
}

export const useSearchStore = create<SearchState>()(
  persist(
    (set) => ({
      query: '',
      isOpen: false,
      recentSearches: [],
      filters: {},
      context: {},
      setQuery: (query) => set({ query }),
      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
      clear: () => set({ query: '', isOpen: false }),
      addRecentSearch: (query) =>
        set((state) => {
          const trimmed = query.trim().toLowerCase();
          if (trimmed.length < 2) return state;
          const filtered = state.recentSearches.filter((s) => s !== trimmed);
          return { recentSearches: [trimmed, ...filtered].slice(0, 10) };
        }),
      clearRecentSearches: () => set({ recentSearches: [] }),
      setFilters: (filters) =>
        set((state) => ({ filters: { ...state.filters, ...filters } })),
      clearFilters: () => set({ filters: {} }),
      setContext: (ctx) => set({ context: ctx }),
    }),
    {
      name: 'sj-search-store',
      partialize: (state) => ({ recentSearches: state.recentSearches }),
    }
  )
);
